import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { fetchStockId } from '../../utils/marketsUtils';
import EmptyState from '../empty-state';
import './promoter-holdings.m.css';

const PromoterHoldings = () => {
  const [promoterHoldingsData, setPromoterHoldingsData] = useState([]);
  const graphDataArray = [];
  const graphDataArray2 = [];
  const labelsArray = [];
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const stockId = fetchStockId();
    const getPromoterHoldingsData = async () => {
      const response = await fetch(`/next/feapi/stock/promoter-holding/${stockId}`);
      const data = await response.json();
      setPromoterHoldingsData(data?.data);
    };
    getPromoterHoldingsData();
  }, []);

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    type: 'bar',
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: 'Promoter Holdings (%)',
      },
    },
    scales: {
      x: {
        ticks: {
          display: true,
        },
        grid: {
          drawBorder: true,
          display: false,
        },
      },
      y: {
        ticks: {
          display: false,
        },
        grid: {
          drawBorder: false,
          display: false,
        },
      },
    },
  };

  promoterHoldingsData?.graph?.map((data) => {
    graphDataArray.push(data.value1);
    graphDataArray2.push(data.value2);
  });

  promoterHoldingsData?.graph?.map((data) => {
    labelsArray.push(data.quarter);
  });

  const labels = labelsArray;
  const data = {
    labels,
    datasets: [
      {
        label: 'Promoter Holdings Value 1',
        data: graphDataArray,
        backgroundColor: '#14C588',
        minBarLength: 7,
      },
      {
        label: 'Promoter Holdings Value 2',
        data: graphDataArray2,
        backgroundColor: '#b7bfc4',
        minBarLength: 7,
      },
    ],
  };

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return !promoterHoldingsData || promoterHoldingsData?.length === 0 ? (
    <div styleName="no-content-outermost">
      <h4 styleName="title">Promoter Holdings</h4>
      <div styleName="no-data-container-ext">
        <div styleName="no-data-container-int">
          <EmptyState subTextMessage={'for this stock at the moment'} />
        </div>
      </div>
    </div>
  ) : (
    <div styleName="promoter-holdings-container">
      <div>
        <h4 styleName="title">Promoter Holdings</h4>
        <div styleName="msg-container">
          <div styleName="gold-text-container">
            <img
              src="https://media.assettype.com/bloombergquint/2022-10/1909e387-602c-41b3-88ae-56c41298518d/gold_coin.png"
              alt="gold-coin"
              width="85px"
              height="85px"
            />
            <p styleName="text-container">{promoterHoldingsData?.header}</p>
          </div>
          <ul>
            {promoterHoldingsData?.messages?.map((msg, index) => (
              <li styleName="message" key={index}>
                {msg?.message}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div styleName="graph-container">
        {graphDataArray?.length === 0 && graphDataArray2?.length === 0 ? (
          <div styleName="no-data-container-ext">
            <div styleName="no-data-container-int">
              <EmptyState subTextMessage={'for this stock at the moment'} />
            </div>
          </div>
        ) : (
          <Bar options={options} data={data} />
        )}
      </div>
    </div>
  );
};

export default PromoterHoldings;
